<template>

<div id="c-floating" class="c-floating">
    <!-- <Transition name="c-floating-campaign-wrap">
    <div v-show="!isScrollHide" class="c-floating__banner">
        <Transition name="c-floating-campaign">
        <div v-show="isShow">
            <a href="#" @click.prevent="anchor('campaign')">
                <picture>
                    <source media="(max-width: 800px)" srcset="/lp/assets/img/lp/campaign/webp/bnr-campaign-sp.webp">
                    <img src="/lp/assets/img/lp/campaign/webp/bnr-campaign-pc.webp" alt="今ならAmazonギフトカード 最大10,000円分プレゼントキャンペーン" width="388" height="128">
                </picture>
            </a>
        </div>
        </Transition>
    </div>
    </Transition> -->

    <Transition name="c-floating-btns">
    <ul v-show="isShow">
        <li>
            <a class="c-btn c-btn--recommend-f c-btn--shadow" href="#" @click.prevent="anchor('recommendations')">おすすめ物件</a>
        </li>
        <li>
            <a class="c-btn c-btn--contact-f c-btn--shadow" href="#" @click.prevent="anchor('c-form')">今すぐ無料相談</a>
            <!-- <Transition name="c-floating-balloon">
            <picture v-show="isShow">
                <source media="(max-width: 800px)" srcset="/lp/assets/img/common/balloon-campaign-sp.png">
                <img class="c-floating__balloon" src="/lp/assets/img/common/balloon-campaign-pc.png" alt="キャンペーン実施中" width="201" height="55">
            </picture>
            </Transition> -->
        </li>
    </ul>
    </Transition>
</div>
</template>

<script>

import { gsap, Quart } from 'gsap/all';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default {
    data() {
        return {
            isScrollHide: false,
        }
    },
    computed: {
        isShow() {
            return this.$store.getters.showFloating;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.callback);
    },
    methods: {
        callback() {
            if (window.scrollY > (window.innerHeight * 0.5)) {
                this.isScrollHide = true;
            } else {
                this.isScrollHide = false;
            }
        },
        anchor(id) {
            gsap.to(window, { duration: 0.8, scrollTo: { y: `#${id}`, autoKill: false }, ease: Quart.easeInOut});
        }
    }
}

</script>